class RewardGroupService {
  constructor(client) {
    this.apiClient = client;
  }

  async getRewardGroups(entityID, { limit = 10, offset = 0, sort = "name_asc" } = {}) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups?limit=${limit}&offset=${offset}&sort=${sort}`
    );
  }

  async getRewardGroup(entityID, rewardGroupID) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/${rewardGroupID}`
    );
  }

  async createRewardGroup(entityID, rewardGroup) {
    return await this.apiClient.post(
      `onepark/${entityID}/reward-groups`,
      rewardGroup
    );
  }

  async updateRewardGroup(entityID, rewardGroupID, rewardGroup) {
    return await this.apiClient.put(
      `onepark/${entityID}/reward-groups/${rewardGroupID}`,
      rewardGroup
    );
  }

  async deleteRewardGroup(entityID, rewardGroupID) {
    return await this.apiClient.delete(
      `onepark/${entityID}/reward-groups/${rewardGroupID}`
    );
  }

  async getEligibleAccessGroups(entityID) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/eligible-access-groups`
    );
  }

  async getDefaultRewardGroupOptions(entityID) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/default-options`
    );
  }

  async setDefaultRewardGroup(entityID, rewardGroupID) {
    return await this.apiClient.put(
      `onepark/${entityID}/reward-groups/${rewardGroupID}/default`
    );
  }

  async checkSignupCodeAvailability(
    entityID,
    signupCode,
    excludeRewardGroupID = null
  ) {
    const query = new URLSearchParams({ signupCode });
    if (excludeRewardGroupID) {
      query.append("excludeRewardGroupID", excludeRewardGroupID);
    }
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/signup-code-availability?${query.toString()}`
    );
  }

  async checkEmailDomainAvailability(
    entityID,
    emailDomain,
    excludeRewardGroupID = null
  ) {
    const query = new URLSearchParams({ emailDomain });
    if (excludeRewardGroupID) {
      query.append("excludeRewardGroupID", excludeRewardGroupID);
    }
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/email-domain-availability?${query.toString()}`
    );
  }
}

export default RewardGroupService;
